module.exports = {
          srcSet: "/_next/static/images/img-vetements@2x-200-3dd9db18b581f988d465155c9c9576f9.jpg"+" 200w",
          images:[ {path: "/_next/static/images/img-vetements@2x-200-3dd9db18b581f988d465155c9c9576f9.jpg",width: 200,height: 171}],
          src: "/_next/static/images/img-vetements@2x-200-3dd9db18b581f988d465155c9c9576f9.jpg",
          toString:function(){return "/_next/static/images/img-vetements@2x-200-3dd9db18b581f988d465155c9c9576f9.jpg"},
          placeholder: undefined,
          width: 200,
          height: 171
      }